var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AI_svg__clip0_3042_58598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 12.0003C11.0203 12.0003 11.3594 12.1408 11.6095 12.3908C11.8595 12.6409 12 12.98 12 13.3337C12 12.98 12.1405 12.6409 12.3905 12.3908C12.6406 12.1408 12.9797 12.0003 13.3333 12.0003C12.9797 12.0003 12.6406 11.8598 12.3905 11.6098C12.1405 11.3598 12 11.0206 12 10.667C12 11.0206 11.8595 11.3598 11.6095 11.6098C11.3594 11.8598 11.0203 12.0003 10.6667 12.0003ZM10.6667 4.00033C11.0203 4.00033 11.3594 4.1408 11.6095 4.39085C11.8595 4.6409 12 4.98004 12 5.33366C12 4.98004 12.1405 4.6409 12.3905 4.39085C12.6406 4.1408 12.9797 4.00033 13.3333 4.00033C12.9797 4.00033 12.6406 3.85985 12.3905 3.6098C12.1405 3.35975 12 3.02061 12 2.66699C12 3.02061 11.8595 3.35975 11.6095 3.6098C11.3594 3.85985 11.0203 4.00033 10.6667 4.00033ZM6 12.0003C6 10.9395 6.42143 9.92204 7.17157 9.1719C7.92172 8.42175 8.93913 8.00033 10 8.00033C8.93913 8.00033 7.92172 7.5789 7.17157 6.82875C6.42143 6.07861 6 5.06119 6 4.00033C6 5.06119 5.57857 6.07861 4.82843 6.82875C4.07828 7.5789 3.06087 8.00033 2 8.00033C3.06087 8.00033 4.07828 8.42175 4.82843 9.1719C5.57857 9.92204 6 10.9395 6 12.0003Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AI_svg__clip0_3042_58598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
};
export default SvgAi;